import React from "react";
import { useLang } from "../../i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-[#0a1430] py-5 overflow-hidden marquee-mask"
    >
      <div className="flex w-max animate-marquee">
        {items.map((item, i) => (
          <div key={i} className="flex items-center whitespace-nowrap">
            <span className="font-head font-bold uppercase tracking-wide text-2xl sm:text-3xl text-slate-500 px-6">
              {item}
            </span>
            <span className="text-amber-400 text-xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
